import { ReactNode } from 'react';
import { Box, Stack } from '@mantine/core';
import { HoverDisplay } from '@/components/HoverDisplay';
import { ListInput } from './ListInput';

export interface UnifiedListItem {
  [key: string]: any;
}

type UnifiedListProps<T extends UnifiedListItem> = {
  items: T[];
  renderItem: (item: T) => ReactNode;
  renderActions: (item: T) => ReactNode;
  renderAdditionalContent?: (item: T) => ReactNode;
  itemClassName?: string;
  gap?: number | string;
};

export function UnifiedList<T extends UnifiedListItem>({
  items,
  renderItem,
  renderActions,
  renderAdditionalContent,
  itemClassName,
  gap = 1,
}: UnifiedListProps<T>) {
  return (
    <HoverDisplay>
      <Stack gap={gap} style={{ width: '100%' }}>
        {items.map((item, idx) => (
          <Stack key={idx} gap={0}>
            <ListInput
              items={[item]}
              renderItem={(i) => renderItem(i)}
              renderItemActions={(i) => renderActions(i)}
              addForm={<div />}
              itemClassName={itemClassName}
              alwaysShowActions={true}
            />
            {renderAdditionalContent && <Box w="100%">{renderAdditionalContent(item)}</Box>}
          </Stack>
        ))}
      </Stack>
    </HoverDisplay>
  );
}
